// const SocialShares = () => {
//     const currentUrl = window.location.href;

//     const shareLinks = {
//         facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
//         twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`,
//         linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}`,
//         email: `mailto:?subject=${encodeURIComponent("Paylaşmak istediğim bir bağlantı")} &body=${encodeURIComponent(currentUrl)}`
//     };

//     const openShare = (url) => {
//         window.open(url, "_blank", "noopener,noreferrer");
//     };

//     return (
//         <div className="mt-12 p-6 sm:p-8 bg-white rounded-lg shadow-md">
//             <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">Paylaş</h3>
//             <div className="flex flex-wrap gap-3 sm:gap-4">
//                 <button
//                     onClick={() => openShare(shareLinks.facebook)}
//                     className="px-4 sm:px-5 py-2.5 bg-gray-100 text-gray-800 border border-gray-300 rounded text-sm sm:text-base hover:bg-gray-200 transition-colors"
//                 >
//                     Facebook
//                 </button>

//                 <button
//                     onClick={() => openShare(shareLinks.twitter)}
//                     className="px-4 sm:px-5 py-2.5 bg-gray-100 text-gray-800 border border-gray-300 rounded text-sm sm:text-base hover:bg-gray-200 transition-colors"
//                 >
//                     Twitter
//                 </button>

//                 <button
//                     onClick={() => openShare(shareLinks.linkedin)}
//                     className="px-4 sm:px-5 py-2.5 bg-gray-100 text-gray-800 border border-gray-300 rounded text-sm sm:text-base hover:bg-gray-200 transition-colors"
//                 >
//                     LinkedIn
//                 </button>

//                 <button
//                     onClick={() => openShare(shareLinks.email)}
//                     className="px-4 sm:px-5 py-2.5 bg-gray-100 text-gray-800 border border-gray-300 rounded text-sm sm:text-base hover:bg-gray-200 transition-colors"
//                 >
//                     E-posta
//                 </button>
//             </div>
//         </div>

//     );
// };

// export default SocialShares;



import React from 'react';
// import { Facebook, Twitter, Linkedin, Email, MessageCircle } from 'react-icons';


import { FaFacebookF, FaXTwitter, FaWhatsapp, FaLinkedinIn } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";


const SocialShares = ({ title = "", description = "" }) => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);
    const encodedTitle = encodeURIComponent(title);
    const encodedDescription = encodeURIComponent(description);

    const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}&summary=${encodedDescription}`,
        whatsapp: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
        email: `mailto:?subject=${encodedTitle}&body=${encodedDescription}%0A%0A${encodedUrl}`
    };

    const openShare = (url, platform) => {
        // Email opens in the same window
        if (platform === 'email') {
            window.location.href = url;
        } else {
            // Other platforms open in a popup window
            const width = 600;
            const height = 500;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;

            window.open(
                url,
                '_blank',
                `width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`
            );
        }
    };

    return (
        <div className="mt-12 p-6 sm:p-8 bg-white rounded-lg shadow-md">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">Paylaş</h3>
            <div className="flex flex-wrap gap-3 sm:gap-4">
                <button
                    onClick={() => openShare(shareLinks.facebook, 'facebook')}
                    className="flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-blue-600 text-white border border-blue-600 rounded text-sm sm:text-base hover:bg-blue-700 transition-colors"
                    aria-label="Facebook'ta paylaş"
                >
                    <FaFacebookF className="w-4 h-4" />
                    Facebook
                </button>

                <button
                    onClick={() => openShare(shareLinks.twitter, 'twitter')}
                    className="flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-black text-white border border-black rounded text-sm sm:text-base hover:bg-gray-800 transition-colors"
                    aria-label="Twitter'da paylaş"
                >
                    <FaXTwitter className="w-4 h-4" />
                    Twitter
                </button>

                <button
                    onClick={() => openShare(shareLinks.linkedin, 'linkedin')}
                    className="flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-blue-700 text-white border border-blue-700 rounded text-sm sm:text-base hover:bg-blue-800 transition-colors"
                    aria-label="LinkedIn'de paylaş"
                >
                    <FaLinkedinIn className="w-4 h-4" />
                    LinkedIn
                </button>

                <button
                    onClick={() => openShare(shareLinks.whatsapp, 'whatsapp')}
                    className="flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-green-500 text-white border border-green-500 rounded text-sm sm:text-base hover:bg-green-600 transition-colors"
                    aria-label="WhatsApp'ta paylaş"
                >
                    <FaWhatsapp className="w-4 h-4" />
                    WhatsApp
                </button>

                <button
                    onClick={() => openShare(shareLinks.email, 'email')}
                    className="flex items-center gap-2 px-4 sm:px-5 py-2.5 bg-gray-100 text-gray-800 border border-gray-300 rounded text-sm sm:text-base hover:bg-gray-200 transition-colors"
                    aria-label="E-posta ile paylaş"
                >
                    <HiOutlineMail className="w-4 h-4" />
                    E-posta
                </button>
            </div>
        </div>
    );
};

export default SocialShares;